export default __webpack_public_path__ + "static/media/arrow-right.d4d033d3.svg";